import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TeacherAssignmentRowFieldsFragment = { __typename?: 'Assignment', id: string, name: string, teacherId?: string | null, updatedAt: any, educatorStatus: Types.AssignmentStatus, minDueDate?: any | null, maxDueDate?: any | null, minStartDate?: any | null, maxStartDate?: any | null, countOfCompletedStudents: number, countOfIncompleteStudents: number, resolvedLockAuthorization?: string };

export type TeacherAssignmentsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.AssignmentFilterInput>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.AssignmentSortInput>> | Types.InputMaybe<Types.AssignmentSortInput>>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  classroomIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  includeResolvedLockAuth?: Types.Scalars['Boolean']['input'];
}>;


export type TeacherAssignmentsQuery = { __typename?: 'RootQueryType', assignmentsAsEducator?: { __typename?: 'KeysetPageOfAssignment', count?: number | null, endKeyset?: string | null, results?: Array<{ __typename?: 'Assignment', id: string, name: string, teacherId?: string | null, updatedAt: any, educatorStatus: Types.AssignmentStatus, minDueDate?: any | null, maxDueDate?: any | null, minStartDate?: any | null, maxStartDate?: any | null, countOfCompletedStudents: number, countOfIncompleteStudents: number, resolvedLockAuthorization?: string }> | null } | null };

export const TeacherAssignmentRowFieldsFragmentDoc = gql`
    fragment TeacherAssignmentRowFields on Assignment {
  id
  name
  teacherId
  updatedAt
  educatorStatus(classroomIds: $classroomIds)
  minDueDate(classroomIds: $classroomIds)
  maxDueDate(classroomIds: $classroomIds)
  minStartDate(classroomIds: $classroomIds)
  maxStartDate(classroomIds: $classroomIds)
  countOfCompletedStudents(classroomIds: $classroomIds)
  countOfIncompleteStudents(classroomIds: $classroomIds)
  resolvedLockAuthorization(classroomIds: $classroomIds) @include(if: $includeResolvedLockAuth)
}
    `;
export const TeacherAssignmentsDocument = gql`
    query TeacherAssignments($filter: AssignmentFilterInput, $sort: [AssignmentSortInput], $first: Int, $after: String, $classroomIds: [ID!], $includeResolvedLockAuth: Boolean! = false) {
  assignmentsAsEducator(
    filter: $filter
    sort: $sort
    first: $first
    after: $after
  ) {
    count
    endKeyset
    results {
      ...TeacherAssignmentRowFields
    }
  }
}
    ${TeacherAssignmentRowFieldsFragmentDoc}`;

/**
 * __useTeacherAssignmentsQuery__
 *
 * To run a query within a React component, call `useTeacherAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeacherAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeacherAssignmentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      classroomIds: // value for 'classroomIds'
 *      includeResolvedLockAuth: // value for 'includeResolvedLockAuth'
 *   },
 * });
 */
export function useTeacherAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>(TeacherAssignmentsDocument, options);
      }
export function useTeacherAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>(TeacherAssignmentsDocument, options);
        }
// @ts-ignore
export function useTeacherAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>;
export function useTeacherAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<TeacherAssignmentsQuery | undefined, TeacherAssignmentsQueryVariables>;
export function useTeacherAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>(TeacherAssignmentsDocument, options);
        }
export type TeacherAssignmentsQueryHookResult = ReturnType<typeof useTeacherAssignmentsQuery>;
export type TeacherAssignmentsLazyQueryHookResult = ReturnType<typeof useTeacherAssignmentsLazyQuery>;
export type TeacherAssignmentsSuspenseQueryHookResult = ReturnType<typeof useTeacherAssignmentsSuspenseQuery>;
export type TeacherAssignmentsQueryResult = Apollo.QueryResult<TeacherAssignmentsQuery, TeacherAssignmentsQueryVariables>;